import { useAuth } from 'react-oidc-context'
import { Link } from 'react-router'
import { AppBar, Box, Button, Grid, Toolbar, Typography } from '@mui/material'

import errorImage from '../../images/error-image.svg'
import meshifyCentralLogo from '../../images/meshify-central-logo.svg'
import { LOCAL_STORAGE_KEYS } from '../../utils/constants'
import useSharedStyles from '../../utils/shared.styles'

import useStyles from './index.styles'

export const ErrorPage = ({ fullPage = false }: { fullPage?: boolean }) => {
  const classes = useStyles
  const sharedClasses = useSharedStyles
  const auth = useAuth()
  return (
    <Grid
      container={true}
      sx={[sharedClasses.centerContentHorizontal, { alignContent: 'center' }, fullPage ? classes.errorGridContainerFullPage : classes.errorGridContainer]}
    >
      <Grid>
        <img src={errorImage} alt="error" aria-label="Error" />
      </Grid>
      <Grid container={true} size={12} sx={[sharedClasses.centerContentHorizontal, classes.typographyWrapper]}>
        <Typography variant="body1" sx={sharedClasses.secondaryText}>
          Having trouble loading this screen. Please try again.
        </Typography>
      </Grid>
      <Grid container={true} size={12} sx={[sharedClasses.centerContentHorizontal, { gap: 7 }]}>
        <Button onClick={() => window.location.reload()}>Refresh Page</Button>
        {fullPage && auth && (
          <Button
            onClick={async () => {
              await auth.signoutRedirect()
              await auth.removeUser()
              localStorage.setItem(LOCAL_STORAGE_KEYS.LOGGED_OUT, 'true')
            }}
          >
            Logout
          </Button>
        )}
      </Grid>
    </Grid>
  )
}

const Fallback = () => {
  const classes = useStyles
  const sharedClasses = useSharedStyles
  return (
    <main>
      <Box sx={{ display: 'flex' }}>
        <AppBar position="fixed" sx={classes.header} elevation={0}>
          <Toolbar sx={classes.toolbar}>
            <Grid container={true} sx={sharedClasses.centerContentVertical}>
              <Grid size={2}>
                <Link to="/" style={classes.headerLogoLink}>
                  <img src={meshifyCentralLogo} alt="logo" style={classes.headerLogo} aria-label="Header Logo" />
                </Link>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      </Box>
      <ErrorPage fullPage={true} />
    </main>
  )
}

export default Fallback
